import React from 'react'

import { Tooltip } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import OLLayerGroup from 'ol/layer/Group'
import { connect } from 'react-redux'

import type OLLayer from 'ol/layer/Layer'

import * as PoziUtils from 'api/utils'
import type { ConfigLayerOptions } from 'config/ConfigLayer'
import LayerLoadStatus from 'drawer/tabs/layers/panels/LayerLoadStatus'
import { getMap } from 'utils/MapUtils'

import LayerContextMenu from './LayerContextMenu'
import LayerLegend from './LayerLegend'

const styles = {
  // Override default LayerTreeNodeTitle styling (which is based on antd)
  root: {},
  filtered: {},
  filteredHidden: {
    display: 'none'
  },
  filteredIcon: {
    maxWidth: 16,
    opacity: 0.54
  },
  nodeTitle: {
    display: 'flex',
    flexDirection: 'row' as const
  },
  nodeTitleMenuButton: {
    padding: 0
  },
  nodeTitleMenuButtonContainer: {
    display: 'flex',
    marginRight: 8
  },
  nodeTitleText: {
    flex: 1,
    overflowWrap: 'anywhere' as const
  },
  nodeTitleTextDisabled: {
    flex: 1,
    color: '#aaaaaa'
  }
}

// This will show the layer title in the tree
class LayerTreeNodeTitle_ extends React.Component<LayerTreeNodeTitleProps, LayerTreeNodeTitleState> {
  render = () => {
    const { classes, olLayer, printUIVisible, layerConf } = this.props

    if (!olLayer) {
      return null
    }

    const { maxResolution, title, titleid, visible } = olLayer.getProperties()

    // console.debug('LayerTreeNodeTitle - render', titleid)

    const map = getMap()
    const mapResolution = map.getView().getResolution() as number

    const layerWithinResolution = PoziUtils.layerIsWithinResolution(olLayer)

    // console.debug('LayerTreeNodeTitle - nodetitlerenderer', titleid, layer)
    // console.debug('LayerTreeNodeTitle - resolution min/current/max true?', titleid, minResolution, mapResolution, maxResolution, layerWithinResolution, layer)

    const layerVisibleAndWithinResolution = visible && layerWithinResolution && !(olLayer instanceof OLLayerGroup)

    const showLayerLegend = layerVisibleAndWithinResolution
    const showContextMenuPanel = !printUIVisible && layerVisibleAndWithinResolution

    let titleTextNode
    if (layerWithinResolution) {
      titleTextNode = (
        <div className={classes.nodeTitleText}>{title}</div>
      )
    } else {
      const inOut = mapResolution >= maxResolution ? 'in' : 'out'
      const tooltip = `Zoom map further ${inOut} to make the layer visible`

      titleTextNode = (
        <div className={classes.nodeTitleTextDisabled} title={tooltip}>{title}</div>
      )
    }

    const layerFiltered = !!layerConf?.propsFilter?.value

    // Check if layer is filtered and visible. If it is show the icon
    const filteredClass = layerFiltered && visible ? classes.filtered : classes.filteredHidden
    const filteredToolTip = 'This layer has a filter applied'

    return (
      <div>
        <div className={classes.nodeTitle}>
          { titleTextNode }
          <div className={classes.nodeTitleMenuButtonContainer}>
            <LayerLoadStatus titleid={ titleid } />
            <div className={filteredClass}>
              <Tooltip title={filteredToolTip}>
                <FilterAltIcon className={classes.filteredIcon} />
              </Tooltip>
            </div>
            <LayerContextMenu titleid={titleid} show={showContextMenuPanel} />
          </div>
        </div>
        <div className={classes.legend}>
          { showLayerLegend && <LayerLegend titleid={titleid} /> }
        </div>
      </div>

    )
  }
}

function mapStateToProps (state: any, ownProps: LayerTreeNodeTitleProps) {
  const { printUIVisible } = state
  const { olLayer } = ownProps

  const titleid = olLayer?.get('titleid')

  const layerConf = state.layers[titleid]

  const props = {
    layerConf,
    printUIVisible
  }

  return props
}

const mapDispatchToProps = () => {
  return {}
}

const LayerTreeNodeTitle = (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LayerTreeNodeTitle_)
  )
)

export default LayerTreeNodeTitle

interface LayerTreeNodeTitleProps {
  classes: Record<string, string>
  layerConf?: ConfigLayerOptions
  olLayer?: OLLayer
  printUIVisible?: boolean
}

interface LayerTreeNodeTitleState {}
